// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"312":"e81304dab0bc8ab7","888":"b2717d80c7f63a4a"}[chunkId] + ".css";
};